import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/libreria",
    name: "Libreria",
    component: () =>
      import(/* webpackChunkName: "libreria" */ "../views/Libreria.vue")
  },
  {
    path: "/detalles/:id",
    name: "Detalles",
    component: () =>
      import(/* webpackChunkName: "bookdetails" */ "../views/BookDetail.vue")
  },
  {
    path: "/combo/:id",
    name: "Combo",
    component: () =>
      import(/* webpackChunkName: "bookdetails" */ "../views/ComboDetail.vue")
  },
  {
    path: "/autores",
    name: "Autores",
    component: () =>
      import(/* webpackChunkName: "autores" */ "../views/Autores.vue")
  },
  {
    path: "/autoresdetail/:id",
    name: "AutoresDetail",
    component: () =>
      import(
        /* webpackChunkName: "autoresdetail" */ "../views/AutoresDetail.vue"
      )
  },
  {
    path: "/contacto",
    name: "Contacto",
    component: () =>
      import(/* webpackChunkName: "contacto" */ "../views/Contacto.vue")
  },
  {
    path: "/nosotros",
    name: "Nosotros",
    component: () =>
      import(/* webpackChunkName: "nosotros" */ "../views/Nosotros.vue")
  },
  {
    path: "/noticias",
    name: "Noticias",
    component: () =>
      import(/* webpackChunkName: "noticias" */ "../views/News/Noticias.vue"),
    children: [
      {
        path: "",
        alias: "dashboard",
        name: "Principal",
        component: () =>
          import(
            /* webpackChunkName: "news_dashboard" */ "../views/News/Dashboard.vue"
          )
      },
      {
        path: "novedades",
        name: "Novedades",
        component: () =>
          import(
            /* webpackChunkName: "news_news" */ "../views/News/Novedades.vue"
          )
      },
      {
        path: "prensa",
        name: "Prensa",
        component: () =>
          import(/* webpackChunkName: "news_press" */ "../views/News/Press.vue")
      },
      {
        path: "detalle/:id",
        name: "Detalle",
        component: () =>
          import(
            /* webpackChunkName: "news_details" */ "../views/News/Details.vue"
          )
      }
    ]
  },
  {
    path: "/cart",
    component: () =>
      import(/* webpackChunkName: "cart_main" */ "../views/Cart/Main.vue"),
    children: [
      {
        path: "",
        alias: "step1",
        name: "Carrito",
        component: () =>
          import(/* webpackChunkName: "cart_step1" */ "../views/Cart/Step1.vue")
      },
      {
        path: "step2",
        name: "Carrito 2",
        component: () =>
          import(/* webpackChunkName: "cart_step2" */ "../views/Cart/Step2.vue")
      },
      {
        path: "step3",
        name: "Carrito 3",
        component: () =>
          import(/* webpackChunkName: "cart_step3" */ "../views/Cart/Step3.vue")
      },
      {
        path: "step4",
        name: "Carrito 4",
        component: () =>
          import(/* webpackChunkName: "cart_step4" */ "../views/Cart/Step4.vue")
      },
      {
        path: "step5",
        name: "Carrito 5",
        component: () =>
          import(/* webpackChunkName: "cart_step5" */ "../views/Cart/Step5.vue")
      }
    ]
  },
  {
    path: "/favoritos",
    name: "Favoritos",
    component: () =>
      import(/* webpackChunkName: "favoritos" */ "../views/Favoritos.vue")
  },
  {
    path: "/compras",
    name: "Compras",
    component: () =>
      import(/* webpackChunkName: "compras" */ "../views/Compras.vue")
  },
  {
    path: "/coupons",
    name: "Cupones",
    component: () =>
      import(/* webpackChunkName: "cupones" */ "../views/Coupons.vue")
  },
  {
    path: "/nologin",
    name: "NoLogin",
    component: () =>
      import(/* webpackChunkName: "compras" */ "../views/NoLogin.vue")
  },
  {
    path: "/distribuidores",
    name: "Distribuidores",
    component: () =>
      import(/* webpackChunkName: "compras" */ "../views/Distribuidores.vue")
  },
];

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

export default router;
